// extracted by mini-css-extract-plugin
export default {"parameters":"MixtureData_parameters__2SVSx","parameter":"MixtureData_parameter__KeNpu"};